import http from './http';

/**
 * Obtiene todos los videos de splash disponibles si esta adjunto a la región.
 */
export async function listSplashImages() {
  const res = await http.get('/splash/image');
  return res.data?.data ?? res.data ?? [];
}

export async function listRegions() {
  const res = await http.get('/regions');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Sube un nuev video de splash.
 */
export async function uploadSplashImage(file, regionId) {
  const formData = new FormData();
  formData.append('file', file);
//   if (typeof order !== 'undefined' && order !== null) {
//     formData.append('order', order);
//   }

  const res = await http.post(`/splash/${regionId}/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data?.data ?? res.data;
}

/**
 * Elimina un video de splash por ID.
 */
export async function deleteSplashImage(id) {
  const res = await http.delete(`/splash/${id}/image`);
  return res.data?.data ?? res.data;
}


